<!--component/common/bottom-modal.wxml-->
<template>
    <div style="cursor: pointer">
        <div @click="show"><slot></slot></div>
        <div class="cu-modal bottom-modal" v-if="hasDisplayDesc"
             :class="cla+' '+(hasDisplayDesc?'show':'')" @click="hide">
            <div class="cu-dialog view">
                <div class="close"></div>
                <div class="part flex flex-direction justify-between view" @click.stop="">
                    <slot name="part"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import App from '../../util/comfun'
  export default {
    props:{
        cla:{
          type:String,
          value:'',
        }
    },
    data () {
      return {
        hasDisplayDesc:false
      }
    },
    components:{
    },
    methods:{
      show(){
        this.hasDisplayDesc=true
        this.event('show')
      },
      hide(){
        this.hasDisplayDesc=false
        this.event('hide')
      },
      event(act){
        this.$emit('event',{act:act});
      },
    },
    created(){

    },
  }
</script>
<style scoped>
    .cu-modal{
        z-index: 99999;
    }
    .cu-modal.bottom-modal .cu-dialog{
        width: 375px;
        opacity: 1;
        background: #ffffff;
        border-radius: 10px 10px 0px 0px;
        bottom: 0;
        position: relative;
        overflow: visible;
        /*height: 1040rpx;*/
        padding:70px 10px 30px;
        margin: 0 auto;
    }
    .cu-modal.bottom-modal.poster .cu-dialog{
        background: #343433;
        padding-bottom: 50px;
        padding-top: 10px;
    }
    .cu-modal.bottom-modal.rightXClose .cu-dialog{
        padding: 0px;
    }
    .part{
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #353535;
        line-height: 20px;
        max-height: 420px;
        overflow-y: auto;
    }
    .auto-height .part{
        max-height: none;
    }
    .close{
        width: 40px;
        height: 20px;
        background: rgba(208,207,207,0.5);
        border-radius: 18px;
        position: absolute;
        top:20px;
        left:calc(50% - 20px);
        background-image: url("https://assets.pfotoo.com/image/like/down.svg");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 12px 8px;
    }
    .noclose .close{
        display: none;
    }
    .no-padding.cu-modal.bottom-modal .cu-dialog{
        padding: 0;
    }
    .no-max-height .part{
        max-height: none;
    }



    .cu-modal.bottom-modal.track-bottom-modal .cu-dialog
    ,.cu-modal.bottom-modal.setMobile-bottom-modal .cu-dialog{
        padding: 15px 20px 40px;
    }
    .cu-modal.bottom-modal.padding-0 .cu-dialog{
        padding: 0;
    }
    .track-bottom-modal .close,
    .setMobile-bottom-modal .close{
        right:10px;
        top:10px;
        left:auto;
        width: 20px;
        height: 20px;
        background-image: url("https://assets.pfotoo.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211227111250.png");
        background-size: 10px 7px;
    }
    .rightXClose .close{
        right:15px;
        top:15px;
        left:auto;
        width: 18px;
        height: 18px;
        background-image: url("https://assets.pfotoo.com/images/close.svg");
        background-size: 100% 100%;
        background-color: transparent;
    }
    .rightXClose.down .close{
        background-image: url("https://assets.pfotoo.com/image/like/down.svg");
    }
    .rightXClose.downfull .close{
        background-image: url("https://assets.pfotoo.com/image/like/down.svg");
        background-size: 14px 14px;
        background-position: center;
        background-color: #e0e0e0;
        width: 20px;
        height: 20px;
    }
    .rightXClose.full .close{
        background-image: url("https://assets.pfotoo.com/images/close-full.png");
    }
    .rightXClose .close:after{
        position: absolute;
        top:-10px;
        right:-10px;
        width: 40px;
        height: 40px;
        z-index: 1;
        content: "";
    }
    .poster .close{
        top:auto;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background: #464645;
        border-radius: 0;
    }
    .poster .close:after{
        content: "取消";
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #bbbbbb;
        line-height: 40px;
        height: 40px;
    }
    .cu-modal.bottom-modal.bg-f5f5f5 .cu-dialog{
        background-color: #f5f5f5;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/bottom-modal.vue